import * as React from 'react';

import { Pill, Tabs } from '@components/common';

import { AllLogicTab } from './AllLogicTab';
import { PreferencesTab } from './PreferencesTab';
import { getTotalRuleCount, TabType } from './utils';

interface Props {
  qualificationReview: Study['qualification_screener_review'];
  setQualificationReview: (qualificationReview: Study['qualification_screener_review']) => void;
  disqualificationReview: Study['disqualification_screener_review'];
  setDisqualificationReview: (disqualificationReview: Study['disqualification_screener_review']) => void;
  screener: Screener;
  onClose: () => void;
  handleEditRule: (question: ScreenerField) => void;
  setQuestions: (questions: ScreenerField[]) => void;
  setActiveTab: (tab: TabType) => void;
  activeTab: TabType;
  disqualificationPageTitle: string;
  setDisqualificationPageTitle: (value: string) => void;
  disqualificationPageContent: string;
  setDisqualificationPageContent: (value: string) => void;
  disqualificationPageTitleError: boolean | null;
  disqualificationPageContentError: boolean | null;
}

export const ScreenerConfigContainer: React.FC<Props> = ({
  qualificationReview,
  setQualificationReview,
  disqualificationReview,
  setDisqualificationReview,
  screener,
  handleEditRule,
  activeTab,
  setActiveTab,
  disqualificationPageTitle,
  setDisqualificationPageTitle,
  disqualificationPageContent,
  setDisqualificationPageContent,
  disqualificationPageTitleError,
  disqualificationPageContentError
}) => {
  const totalRuleCount = React.useMemo(() => getTotalRuleCount(screener), [screener]);

  const tabs: TabType[] = ['preferences', 'all_logic'];
  const tabLabels: Record<TabType, React.ReactNode> = {
    preferences: <span>Preferences</span>,
    all_logic: (
      <div className='flex items-center gap-2'>
        <span>All Logic</span>
        <Pill color='blue' className='normal-case'>
          {totalRuleCount}
        </Pill>
      </div>
    )
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case 'preferences':
        return (
          <PreferencesTab
            qualificationReview={qualificationReview}
            setQualificationReview={setQualificationReview}
            disqualificationReview={disqualificationReview}
            setDisqualificationReview={setDisqualificationReview}
            disqualificationPageTitle={disqualificationPageTitle}
            setDisqualificationPageTitle={setDisqualificationPageTitle}
            disqualificationPageContent={disqualificationPageContent}
            setDisqualificationPageContent={setDisqualificationPageContent}
            disqualificationPageTitleError={disqualificationPageTitleError}
            disqualificationPageContentError={disqualificationPageContentError}
          />
        );
      case 'all_logic':
        return <AllLogicTab screener={screener} onEditRule={handleEditRule} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className='px-6 pt-6'>
        <Tabs<TabType> current={activeTab} tabs={tabs} onSelect={setActiveTab} labels={tabLabels} />
      </div>
      <hr className='-mx-6' />
      {renderTabContent()}
    </div>
  );
};
